// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Oo9U6","social":"Header_social__Y1mJK"};